import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'at-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {

  @Input() size: string;
  @Input() color: string;
  @Input() image: string;
  @Input() initials: string;

  constructor() { }

  ngOnInit() {
  }

}
